export default __webpack_public_path__ + "static/media/Elements_04.7c25eff3.png";